module.exports = __webpack_public_path__ + "static/1-6ad1efa0ba5c1c41a002d3bd82c056bd.jpeg";